export function isNullOrEmptyArray(value) {
  return !value || !value.length > 0;
}
